import React, { Component } from 'react';

import {
  Redirect
} from 'react-router-dom';

class Logout extends Component {

  componentDidMount() {
    localStorage.removeItem('username');
    localStorage.removeItem('uid');
    localStorage.removeItem('roles');
    localStorage.removeItem('csrf_token');
    localStorage.removeItem('logout_token');
    localStorage.removeItem('auth');
    window.dispatchEvent(new Event('auth-changed'));
  }

  render(){
    return (
      <Redirect to="/" />
    );
  }
}

export default Logout
